module.exports = __webpack_public_path__ + "static/media/green.9f93b342.svg";